module.exports = __webpack_public_path__ + "static/media/DSC_0045.5d0cf542.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0045.jpg
// module id = 623
// module chunks = 0